import React, { useState } from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { Polyline } from './external/Polyline.tsx';
import { formatDistance } from '../helpers/utils';

const MyPolyline = ({ route, active, color, onToggle }) => {
  const [infoPosition, setInfoPosition] = useState(null);
  const handleClick = (e) => {
    setInfoPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    onToggle();
  };

  return (
    <>
      <Polyline
        encodedPath={route.polyline}
        strokeWeight={4}
        strokeColor={color}
        onClick={handleClick}
        position={infoPosition}
      />
      {active && (
        <InfoWindow position={infoPosition} onCloseClick={onToggle}>
          <div className="direction-info-window">
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
              {route.duration} min
            </div>
            <div>{formatDistance(route.distance)}</div>
          </div>
        </InfoWindow>
      )}
    </>
  );
};

export default MyPolyline;
